export default __webpack_public_path__ + "static/media/drmc-science.4ea1541c.jpg";